<template>
  <div>
    <Nav current="我的公司"></Nav>
    <div class="content">
      <div class="title">添加编号</div>
      <div class="form">
        <div class="form_item">
          <span class="item_name">编号</span>
          <input type="text" ref="number" v-model="dataList.name" />
          <span class="xing-huang">* 为必填项</span>
        </div>
        <div class="form_item">
          <span class="item_name indent">姓名</span>
          <input type="text" v-model="dataList.alias" />
        </div>
        <div class="form_item">
          <span class="item_name indent">使用者手机号</span>
          <input type="text" v-model="dataList.mobile" />
          <span class="xing-lv">* 可稍后设置</span>
        </div>
        <div class="form_item">
          <span class="item_name indent">部门</span>
          <input type="text" v-model="dataList.departmentName" disabled />
          <span class="btn" ref="department" @click="showDisappearDepart"
            >选择</span
          >
        </div>
        <div class="form_item">
          <span class="item_name indent">角色</span>
          <input type="text" v-model="dataList.roleName" disabled/>
        </div>
        <div class="form_item">
          <span class="item_name indent">备注</span>
          <input type="text" v-model="dataList.remark" />
        </div>
        <div class="form_item">
          <span class="item_name indent">编号是否同步第三方</span>
          <div class="radio">
            <template>
              <el-radio v-model="dataList.shadowTokenSignal" label="false"
                >否</el-radio
              >
              <el-radio v-model="dataList.shadowTokenSignal" label="true"
                >是</el-radio
              >
            </template>
          </div>
        </div>
      </div>

    </div>
    <!-- 弹框  -->
    <div class="ec_tip none" ref="none" v-if="btnType == 0">
      <div class="ec-title">
        请选择部门 <span id="close" @click="disappear">x</span>
      </div>
      <div class="ec-cont">
        <input type="text" placeholder="查找部门" v-model="name" /><i
          class="el-icon-search" 
          @click="searchTreeParment"
        ></i>
      </div>
      <div class="tree">
        <el-tree
          :data="parentList"
          show-checkbox
          node-key="id"
          :expand-on-click-node=false
          check-strictly
          current-node-key
          :default-checked-keys="[dataList.departmentId]"
          ref="treeForm"
          :props="defaultProps"
          @check-change="handleNodeClick1"
        >
        </el-tree>
      </div>
      <div class="ec-but">
        <input type="button" value="确定" @click="disappear" />
      </div>
    </div>
    <el-row class="el-row">
      <el-button type="primary" class="el-button btnSty" @click="addNumberInfo"
        >保存</el-button
      >
      <el-button class="el-button btnret" @click="retSuper">返回</el-button>
    </el-row>
    <div class="mask none" ref="none"></div>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
export default {
  components: {
    Nav,
  },
  data() {
    return {
      btnType: 0,
      disabledList: [],
      inputList: [],
      parentList: [],
      roleList: [],
      // shadowTokenSignal: "false",
      treeType: "",
      name: "",
      dialogTableVisible: false,
      dataList: {
        name: "",
        alias: "",
        mobile: "",
        departmentId: "",
        departmentName: "",
        roleName: "",
        roleId: "",
        remark: "",
        shadowTokenSignal: "false",
      },
      departmentList: [],
      treeData: [],
      checkedId: "",
      defaultProps: {
        children: "children",
        label: "name",
      },
    };
  },
  created() {},
  mounted() {
    this.dataList.roleId = this.$route.query.roleId
    this.dataList.roleName = this.$route.query.name
    this.disabledList = document.getElementsByClassName("none");
    // console.log(this.$route.query.name)
  },
  methods: {
    //保存
    addNumberInfo() {
      let _this = this;
      let params = _this.dataList;
      let val = this.$refs.number.value;
      console.log(val);
        http.post(apiData.addNumber, true, params, (res) => {
          if (res.data.code == 200) {
            _this.$router.go(-1);
          } 
        });
     
    },
    // 搜索部门
    searchTreeParment() {
      let _this = this;
      console.log(_this.name);
      http.get(
        apiData.showParentList,
        true,
        { name: _this.name },
        function (res) {
          console.log(res.data.data);
          _this.parentList = res.data.data;
        }
      );
    },

    // 搜索角色
    searchTreeRole() {
      let _this = this;
      console.log(_this.name);
      http.get( apiData.showRoleList,true, { name: _this.name },function (res){
        console.log(res.data.data);
         _this.parentList = res.data.data;
        }
      );
    },
    // 显示选择部门树形控件
    showDisappearDepart() {
      let _this = this;
      _this.btnType = 0;
   
      for (var i = 0; i < _this.disabledList.length; i++) {
        _this.disabledList[i].style.display = "block";
      }
      // 请求部门列表
      http.get(apiData.showParentList, true, { }, function (res) {
        console.log(res.data.data);
        _this.parentList = res.data.data;
      });
    },
    // 显示选择角色树形控件
    showDisappearRole() {
      let _this = this;
      _this.btnType = 1;
      _this.disabledList = document.getElementsByClassName("none");
      for (var i = 0; i < _this.disabledList.length; i++) {
        _this.disabledList[i].style.display = "block";
      }
    },

    disappear() {
      let _this = this;
      //蒙层消失
      for (var i = 0; i < _this.disabledList.length; i++) {
        _this.disabledList[i].style.display = "none";
      }
    },
    //@check-change实现单选
    handleNodeClick1(data, checked, node) {
      // console.log(1);
      let _this = this;
      if (checked === true) {
        this.checkedId = data.id;
         this.$nextTick(() => {
          this.$refs.treeForm.setCheckedNodes([data]);
          // this.$refs.treeForm.setCheckedKeys([]);
        });
        // console.log('选中事件2',data);
        _this.dataList.departmentName = data.name;
        _this.dataList.departmentId = data.id;
      } else {
        
      }
    },

    handleNodeClick2(data, checked, node) {
      let _this = this;
      if (checked === true) {
        this.checkedId = data.id;
        console.log(_this.checkedId);
        _this.dataList.roleName = data.name;
        _this.dataList.roleId = data.id;

         this.$nextTick(() => {
          this.$refs.treeForm.setCheckedNodes([data]);
          // this.$refs.treeForm.setCheckedKeys([]);
        });
      } 

    },
    // 获取树形选中节点

    //选择上级单位

    

    retSuper() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="less">
.content {
  text-align: left;
  .title {
    width: 100%;
    height: 56px;
    line-height: 56px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    text-indent: 10px;
    float: left;
  }

  .form {
    .form_item {
      display: flex;
      width: 100%;
      height: 40px;
      font-size: 14px;
      line-height: 40px;
      text-indent: 10px;

      input {
        width: 200px;
        height: 30px;
        margin-top: 5px;

        background: transparent;
        border: 1px solid rgb(204, 204, 204);
        text-indent: 10px;
      }
      .btn {
        width: 50px;
        color: #6cbef6;
      }
      .radio {
        line-height: 40px;
        .el-radio {
          margin: 0;
        }
      }
      .xing-huang {
        color: #ffba1a;
      }
      .xing-lv {
        color: #55c4b8;
      }
    }

    .item_name {
      width: 160px;
      display: block;
      color: #666;
      padding-left: 10px;
    }

    .form_item:nth-child(odd) {
      background: #f8f8f8;
    }
  }
}
.layyer {
  width: 420px;
  height: 300px;
}
.closeBtn {
  width: 420px;
  height: 30px;
  display: contents;
  color: #fff;
  background: #55c4b8;
}

.el-row {
  text-align: center;
  height: 40px;
  width: 100%;
  margin: 200px 0;
}

.btnret:hover {
  background: #55c4b8;
  color: #f8f8f8;
}
.el-button:hover {
  background: #55c4b8;
  border: 1px solid #55c4b8;
  color: #f8f8f8;
}
.el-button {
  width: 200px;
  height: 40px;
  border: 1px solid #55c4b8;
  color: #55c4b8;
}

.btnSty {
  background: #55c4b8;
  color: #fff;
}
.btnSty:hover {
  background: #55c4b8;
  color: #fff;
  border: 1px solid #55c4b8;
}
.mask {
  width: 100%;
  height: 980px;
  position: absolute;
  top: 0;
  display: none;
  background-color: rgba(0, 0, 0, 0.5);
    z-index:999;
}

/* 弹框 */
.ec_tip {
  width: 460px;
  height: 70%;
  display: none;
  position: absolute;
  left: 40%;
  top: 100px;
  background: #f8f8f8;
  color: #fff;
  z-index: 99999;
}

.ec-title {
  width: 100%;
  height: 40px;
  background-color: #75c0b6;
  text-align: center;
  line-height: 40px;
  position: relative;
}

.ec-title span {
  width: 20px;
  height: 20px;
  display: block;
  line-height: 16px;
  border: 1px solid #fff;
  border-radius: 50%;
  float: right;
  margin: 10px 10px 0 0;
}

.ec-but {
  position: absolute;
  bottom: 30px;
  margin: 0 auto;
}

.ec-but input {
  width: 200px;
  height: 40px;
  margin-left: 128px;
  float: left;
  border-radius: 5px;
  background-color: #fff;
}
.ec-cont {
  padding: 20px 0 0 20px;
  color: #000;
  display: flex;
  margin-left: 15px;
  input {
    width: 363px;
    height: 30px;
    padding: 4px 6px 4px 5px;
    border: 1px solid #ccc;
    text-align: center;
  }
  i {
    width: 30px;
    height: 30px;
    font-size: 25px;
    margin-top: 2px;
    display: block;
    margin-left: 5px;
    color: #ccc;
  }
}
.endTime_tr {
  float: left;
}
.tree {
  margin-top: 15px;
}
.el-tree {
  height: 370px;
  overflow-x: hidden;
}

.ec-but input:first-child {
  color: #fff;
  background-color: #75c0b6;
  border: 1px solid #75c0b6;
}

.active {
  background-color: #eee;
}
</style>
